import React , {Component} from 'react';
import {
    Page  , Link , Actions , ActionsGroup , ActionsLabel , ActionsButton , Popup , Navbar , NavRight
} from 'framework7-react';
import NumberFormat from 'react-number-format';

import { connect } from "react-redux";
import {
    toolbar
} from "../actions";
import * as axios from "axios/index";
import validator from "validator";
import Loading from "../Loader/Loading";
import * as vars from './Vars';

class Payment extends Component{

    constructor(props){
        super(props)
        this.state = {
            errors : {} ,

            fields : {
                creditUse : false ,
                discountCode : '' ,
            },
            requestInPageLoading : false,
            modal : {
                modalMessageShow : false ,
                modalMessageBody : "" ,
                modalMessageTitle : "" ,
            } ,

            discountCheckModal : false ,
            requestError : false ,

            discountCode : []
        }
    }


    handleModalClose(){
        this.setState({
            modal : {
                modalMessageShow : false ,
            }
        })
    }

    handleValidation(callback){
        let { fields } = this.state
        let errors = {}
        let formIsValid = true
        if (validator.isEmpty(fields.discountCode))
        {
            formIsValid = false;
            errors['discountCode'] = 'کد تخفیف را وارد کنید';
        }

        this.setState({errors} , () => {
            return callback(formIsValid)
        })
    }

    handleSubmit(event){
        event.preventDefault()

        console.log(this.props.branch)


        this.handleValidation( (valid) => {
            if (valid)
            {

                this.setState({
                    requestInPageLoading : true
                })

                let data = new FormData()
                data.append('user_app_version' , '100' )
                data.append('a_token' , 'webapp' )
                data.append('mobile' , localStorage.getItem('mobile') )
                data.append('imei_code' , localStorage.getItem('imeiCode') )
                data.append('users_ID' , localStorage.getItem('users_ID') )
                data.append('branchs_ID' , this.props.branch.ID )
                data.append('discounts_code' , this.state.fields.discountCode )

                axios.post(vars.PreUrl + 'https://www.lavefood.com/v1/discount/code/check' , data )
                    .then(response => {
                        console.log(response)
                        let data = response.data.result[0]

                        if(data.error === 0)
                        {
                            this.setState({
                                requestInPageLoading : false ,
                                requestLoading : false ,
                                modal : {
                                    modalMessageShow : true ,
                                    modalMessageBody :  "کد تخفیف برای شما معتبر می باشد" ,
                                    modalMessageTitle : "پیغام" ,


                                } ,
                                requestError : false ,
                                discountCode : data.discounts
                            })


                            localStorage.setItem('discountCodeString' , this.state.fields.discountCode)
                            localStorage.setItem('discountCode' , JSON.stringify(data.discounts))
                            console.log(data.discounts)

                        }
                        else
                        {
                            console.log(data)
                            this.setState({
                                requestInPageLoading : false ,
                                modal : {
                                    modalMessageShow : true ,
                                    modalMessageBody :  data.error_body ,
                                    modalMessageTitle : "خطا" ,


                                },
                                requestError : true ,
                                discountCode : []
                            })

                            localStorage.removeItem('discountCodeString' )
                            localStorage.removeItem('discountCode' )
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        this.setState({
                            requestInPageLoading : false ,
                            modal : {
                                modalMessageShow : true ,
                                modalMessageBody :  "مشکلی پیش آمده. لطفا مجددا تلاش کنید",
                                modalMessageTitle : "خطا" ,


                            },
                            requestError : true,
                            discountCode : []
                        })

                        localStorage.removeItem('discountCodeString' )
                        localStorage.removeItem('discountCode' )
                    })



            }

        })
    }


    onPageBeforeIn(){
        this.props.toolbar(false)
    }


    handleCreditUse(){

        this.setState({
            fields : {
                ...this.state.fields ,
                creditUse : !this.state.fields.creditUse
            }
        })


        localStorage.setItem('creditUse' , this.state.fields.creditUse )
    }

    handleChange(event){
        let fields = this.state.fields
        let target = event.target
        fields[target.name] = target.value
        this.setState({fields})
    }

    componentWillMount() {
        if (this.props.branch.length === 0)
        {
            this.$f7router.navigate('/')
            return false
        }

        localStorage.setItem('creditUse' , false )
        localStorage.removeItem('discountCodeString' )
        localStorage.removeItem('discountCode' )
    }
    componentDidMount(){
        if (this.props.branch.length === 0)
        {
            this.$f7router.navigate('/')
            return false
        }
    }




    render(){
        const { products, cart, branch  } = this.props
        const {errors} = this.state


        let cartCount = 0
        cart.forEach(function ( item ) {
            cartCount += item
        })

        let maxBranchDiscount = 0
        if (branch.length !== 0)
        {
            branch.discounts.map((item , index)=> {
                if (parseInt(item.percent_branchs) > maxBranchDiscount)
                {
                    maxBranchDiscount = parseInt(item.percent_branchs)
                }
                if (parseInt(item.percent_app) > maxBranchDiscount)
                {
                    maxBranchDiscount = parseInt(item.percent_app)
                }
            })
        }

        let totalPrice = 0
        let totalDiscount = 0
        cart.forEach( function(count , id){
                totalPrice += products[id]["price"] * count
                totalDiscount += products[id]["price"] * count * products[id]["food_discount"] / 100
            }
        )

        totalDiscount =  Math.round(totalDiscount + ( (totalPrice - totalDiscount)  * maxBranchDiscount / 100))


        let taxPrice =  Math.round(totalPrice * branch.tax / 100)
        let payablePrice = totalPrice - totalDiscount + taxPrice


        if (this.state.discountCode.length !== 0)
        {
            let discountCode = this.state.discountCode
            let discountCodePrice = 0
            console.log(discountCode)
            if(discountCode.percent_code > 0)
            {
                discountCodePrice =   Math.round(discountCode.percent_code * payablePrice / 100)
                if (discountCode.max_price > 0 && discountCodePrice > discountCode.max_price)
                {
                    discountCodePrice = discountCode.max_price
                }
            }
            else if(discountCode.price_code)
            {
                discountCodePrice = discountCode.price_code
            }
            totalDiscount += discountCodePrice

            payablePrice -=  discountCodePrice
        }


        if(this.state.fields.creditUse === true)
        {
            payablePrice -= parseInt(localStorage.getItem('usersCredit'))
        }

        if (payablePrice < 0)
            payablePrice = 0

        return(
            <Page name="Payment" className="bg-white" onPageBeforeIn={this.onPageBeforeIn.bind(this)}>

                <div id="inner-header" >

                    <Link back id="back">
                        <img src="https://www.lavefood.com/webappassets/images/back.svg" />
                    </Link>
                    <div className="title">
                        نحوه پرداخت
                    </div>
                </div>

                <Loading show={this.state.requestInPageLoading} />

                <div id="inner-header-separator" />

                <div id="payment">
                    <div className="item">

                        <div className="bank-selector selected">
                            <div className="b-row no-gutters align-items-center b-row-eq-height">
                                <div className="b-col-3 col-first">
                                    <div className="img-container-icon">
                                        <img className="img" src="https://www.lavefood.com/webappassets/images/cart.svg" />
                                    </div>
                                </div>

                                <div className="b-col-6">
                                    <div className="center-container">

                                        <div className="title">
                                            پرداخت آنلاین
                                        </div>
                                        <div className="sub-title">
                                            با تمامی کارتهای شتاب
                                        </div>
                                    </div>
                                </div>

                                <div className="b-col-3">
                                    <div className="img-container-bank">
                                        <div>
                                            <img className="img" src="https://www.lavefood.com/webappassets/images/saman_logo.jpg" />
                                            <span className="name">بانک سامان</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="item">


                        <div id="credit-use"  >
                            <label className="credit-use-label">

                                <div className="b-row  align-items-center">
                                    <div className="b-col-auto">
                                        <input type="checkbox"  checked={this.state.fields.creditUse ? "checked" : false} value={this.state.fields.creditUse} onChange={this.handleCreditUse.bind(this)}/>
                                        <span className="check-mark" />
                                    </div>
                                    <div className="b-col-auto">
                                        <div className="text-container">
                                            <div>  پرداخت از طریق اعتبار</div>
                                            <div>
                                                ( اعتبار شما : {<NumberFormat value={localStorage.getItem('usersCredit')}  displayType={'text'} thousandSeparator={true}  />} تومان )
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </label>
                        </div>
                    </div>


                    <div className="item" onClick={()=> this.setState({discountCheckModal : true})}>
                        <div id="discount-link">
                            <img className="img" src="https://www.lavefood.com/webappassets/images/gift.svg"  />
                            <span className="text">
                                درج کد تخفیف
                            </span>
                            <span className="icon">
                                +
                            </span>
                        </div>
                    </div>
                </div>



                {
                    cartCount > 0 ? (

                            <div id="cart-footer">
                                <div className="content">

                                    <div className="b-container b-0 ">

                                        <div className="b-row no-gutters row-eq-height justify-content-between">
                                            <div className="b-col-auto">
                                                <div className="total">
                                                    جمع کل و مالیات
                                                </div>
                                            </div>
                                            <div className="b-col-auto">
                                                <div className="total">
                                                    {<NumberFormat value={totalPrice} displayType={'text'} thousandSeparator={true}  />} تومان


                                                </div>
                                            </div>
                                        </div>


                                        <div className="b-row no-gutters row-eq-height justify-content-between">
                                            <div className="b-col-auto">
                                                <div className="discount">
                                                    تخفیف ویژه
                                                </div>
                                            </div>
                                            <div className="b-col-auto">
                                                <div className="discount">
                                                    {<NumberFormat value={totalDiscount} displayType={'text'} thousandSeparator={true}  />} تومان

                                                </div>
                                            </div>
                                        </div>


                                        <div className="b-row no-gutters row-eq-height justify-content-between">
                                            <div className="b-col-auto">
                                                <div className="payable">
                                                    مبلغ کل
                                                </div>
                                            </div>
                                            <div className="b-col-auto">
                                                <div className="payable">
                                                    {<NumberFormat value={payablePrice} displayType={'text'} thousandSeparator={true}  />} تومان

                                                </div>
                                            </div>
                                        </div>



                                    </div>



                                </div>

                                <Link href={localStorage.getItem('logged') !== undefined && localStorage.getItem('logged') !== null ? `/Invoice/` : `/login-singup/`} className="btn btn-block " id="go-to-address-select">
                                    ادامه ( فاکتور نهایی )
                                </Link>
                            </div>
                        ) :
                        ( `` )
                }









                <Actions className="modal-custom-1"  ref="actionsOneGroup" opened={this.state.modal.modalMessageShow} onActionsClosed={() => this.handleModalClose(false)}>
                    <ActionsGroup>
                        <ActionsLabel>{this.state.modal.modalMessageTitle}</ActionsLabel>
                        <div className="content">
                            {this.state.modal.modalMessageBody}
                        </div>
                        <div className="footer">
                            <ActionsButton>
                                <span className="footer-close" onClick={ () => this.state.requestError ? `` : this.setState({discountCheckModal : false}) }>
                                    خب
                                </span>
                            </ActionsButton>
                        </div>
                    </ActionsGroup>
                </Actions>


                <Popup id="discount-code-form-popup" swipeToClose opened={this.state.discountCheckModal} onPopupClosed={() => this.setState({discountCheckModal : false})}>
                    <Loading show={this.state.requestInPageLoading} />
                    <Page>
                        <Navbar title="بررسی کد تخفیف">
                            <NavRight>
                                <Link popupClose>بستن</Link>
                            </NavRight>
                        </Navbar>
                        <div className="display-flex justify-content-center align-items-center h-100">

                            <form onSubmit={this.handleSubmit.bind(this)}   className="input-container pt-0">



                                <label htmlFor="phone" className="label">
                                    <img src="https://www.lavefood.com/webappassets/images/gift.svg" className="img"/>
                                    <div className="title">
                                        کد تخفیف
                                    </div>
                                </label>
                                <div className="form-group">
                                    <input type="text" value={this.state.fields.discountCode} name="discountCode" onChange={this.handleChange.bind(this)} className="form-control input-field"/>
                                    <span className={["invalid-feedback" ,  errors['discountCode'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['discountCode'] }</span>
                                </div>


                                <div className="input-group">
                                    <button type="submit" className="btn btn-custom-4 ">
                                        بررسی
                                    </button>
                                </div>

                            </form>



                        </div>
                    </Page>
                </Popup>



            </Page>
        )
    }
}

const mapDispatchToProps = dispatch => ({


    toolbar : show => dispatch(toolbar(show)) ,


})

const mapStateToProps = state => {
    return {
        products : state.products ,
        cart : state.cart ,
        branch : state.branch ,
        toolbarShow : state.toolbar
    }
}

export default connect( mapStateToProps , mapDispatchToProps)(Payment);